<template>
  <div class="SubPage__container">
    <PageHeader />
    <div class="SubPage__contentGrid SubPage__firstGrid">
      <Breadcrumbs :crumbs="crumbs" />
      <div class="SubPage__header columns is-mobile">
        <div class="column">
          <h1 class="SubPage__title">Download</h1>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-two-thirds">
          <HeroSlider :slides="slides" :heightFirst="true" />
        </div>
        <div class="column is-one-third">
          <SalesContainer :config="salesContainerConfig" />
        </div>
      </div>
    </div>
    <div class="SubPage__contentGrid">
      <h2 class="SubPage__subHeading">Broschüren & Flyer</h2>
      <DownloadList :config="listConfig" />
    </div>
    <Footer />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script>
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import Footer from "../Footer/Footer";
import SalesContainer from "../SalesContainer/SalesContainer";
import PageHeader from "../PageHeader/PageHeader";
import CookieDisclaimer from "../CookieDisclaimer/CookieDisclaimer";
import DownloadList from "../DownloadList/DownloadList";
import HeroSlider from "../HeroSlider/HeroSlider";

export default {
  name: "DataSheetListPage",
  components: {
    Breadcrumbs,
    Footer,
    SalesContainer,
    PageHeader,
    CookieDisclaimer,
    DownloadList,
    HeroSlider
  },
  data() {
    return {
      cookieDisclaimerConfig: {
        text:
          "Unsere Webseite verwendet Cookies. Durch die weitere Nutzung stimmen Sie der Verwendung zu.",
        link: {
          text: "Weitere Informationen",
          url: "#"
        },
        button: {
          text: "Zustimmen",
          colour: "blue"
        }
      },
      crumbs: [
        {
          title: "Startseite",
          url: "#"
        },
        {
          title: "Download",
          url: "#"
        },
        {
          title: "Broschüren & Flyer",
          url: "#"
        }
      ],
      slides: [
        {
          image: "https://picsum.photos/662/257?random=1",
          newWindow: false,
          url: "#"
        },
        {
          image: "https://picsum.photos/662/257?random=2",
          newWindow: false,
          url: "#"
        },
        {
          image: "https://picsum.photos/662/257?random=3",
          newWindow: false,
          url: "#"
        }
      ],
      salesContainerConfig: {
        title: "Vertriebskontakt",
        text: "Fragen? Finden Sie Ihren Ansprechpartner im WIKA-Vertriebsteam.",
        icon: "fas fa-user-tie",
        input: {
          placeholderText: "Postleitzahl eingeben",
          submitUrl: "contact_de_at.WIKA?cnType=1&cnEntry="
        },
        buttons: [
          {
            icon: "far fa-comments",
            text: "Jetzt chatten",
            offlineText: "Nachricht senden"
          },
          {
            icon: "fas fa-envelope",
            text: "Kontaktformular",
            linkUrl: "#"
          }
        ]
      },
      listConfig: {
        listTitle: "Hier bunte Broschüren und mitreißende Flyer downloaden",
        hasSearch: false,
        texts: {
          resultText: "Anzahl der gefundenen Einträge:",
          resetText: "",
          helpText: "Bitte wählen Sie eine oder mehrerer Filteroptionen.",
          pdf: "PDF",
          ebook: "E-Book",
          wishlist: "Merkzettel",
          productDetail: "Details",
          productDatasheet: "Datenblatt"
        },
        resetSelectOption: "Alle",
        loadInitialData: true,
        url:
          "http://www-qa.wika.dev.intern.etecture.de/de-de/dokumentenkategorien-json-99497.json",
        withExternalData: false,
        mappingUrl:
          "http://www-qa.wika.dev.intern.etecture.de/de-de/keyword_translations_json.WIKA",
        filters: [
          {
            hasFilter: false,
            key: "area",
            label: "Bereich",
            sort: "asc",
            initialSelectOption: "Bitte wählen..."
          }
        ],
        pagination: {
          texts: {
            page: "Seite",
            of: "von"
          },
          resultsPerPage: 9,
          resultsSelect: {
            initialSelectOption: "9 Einträge pro Seite",
            selectOptions: [
              "9 Einträge pro Seite",
              "18 Einträge pro Seite",
              "Alle"
            ]
          }
        }
      }
    };
  }
};
</script>
